export default {
    namespaced: true,
    state: {
        visiblePageLoading: false,
        visibleAppHeader: true
    },
    getters: {},
    mutations: {
        TOOGLE_APP_HEADER(state: { visibleAppHeader: boolean }, payload: boolean) {
            state.visibleAppHeader = payload;
        },
        SET_PAGE_LOADING_STATUS(state: { visiblePageLoading: boolean }, payload: boolean) {
            state.visiblePageLoading = payload;
        }
    }
};
